import React, { useEffect, useState } from 'react';
// import { Link } from 'react-router-dom';
import { Card, CardBody, Table } from 'reactstrap';
import { useQuery } from '@tanstack/react-query';
import Popup from '../../components/popup/Popup';
import FormTimeOff from './FormTimeOff';
import useAxios from '../../hooks/useAxios';
import { showToast } from '../../components/toast/Toast';
import TabMenu from '../../components/tabMenu/TabMenu';
import MyButton from '../../components/myButton/MyButton';
import MyTable from '../../components/MyTable/MyTable';
import FetchStatus from '../../components/fetchStatus/FetchStatus';
import Tab3 from './Tab3';
import MyBadge from '../../components/myBadge/MyBadge';
import DayView from '../../components/dayView/DayView';
import PopupConfirmation from '../../components/popup/PopupConfirmation';
import TimeOffDetail from '../admin/request/TimeOffDetail';
import Pagination from '../../components/pagination/Pagination';
import getRowNumber from '../../utils/getRowNumber';

const tabMenus = [
  {
    id: 1,
    name: 'Daftar Pengajuan Cuti',
    icon: 'event',
  },
  {
    id: 3,
    name: 'Saldo Cuti',
    icon: 'info',
  },
];

const RequestTimeOfff = () => {
  const [popup1, setPopup1] = useState(false);
  const [popup2, setPopup2] = useState(false);
  const [popup3, setPopup3] = useState(false);
  const [popup4, setPopup4] = useState(false);
  const [listData, setListData] = useState([]);
  const [metaData, setMetaData] = useState({});
  const [selectedReason, setSelectedReason] = useState(null);
  const [selectedId, setSelectedId] = useState(undefined);
  const [selectedData, setSelectedData] = useState(undefined);
  const [isCanceling, setIsCanceling] = useState(false);
  const [selectedTab, setSelectedTab] = useState(1);
  const [selectedTotalDayTaken, setSelectedTotalDayTaken] = useState(undefined);
  const [selectedDateRange, setSelectedDateRange] = useState(undefined);
  const [isCheckboxActive, setIsCheckboxActive] = useState(false);
  const [limit, setLimit] = useState(10);
  const [page, setPage] = useState(1);

  const api = useAxios();

  const { isLoading, error, data, refetch } = useQuery({
    queryKey: ['requests', limit, page],
    queryFn: () =>
      api.get(`request/employee-request?limit=${limit}&page=${page}`).then((res) => {
        return res.data;
      }),
  });

  useEffect(() => {
    if (data) {
      setListData(data.data);
      setMetaData(data.meta);
    }
  }, [data]);

  const togglePopup1 = () => {
    setPopup1(!popup1);
  };

  const togglePopup2 = (reason) => {
    setSelectedReason(reason);
    setPopup2(!popup2);
  };

  const togglePopup4 = (id) => {
    setSelectedId(id);
    setPopup4(!popup4);
  };

  const toggleDetailRequest = (item, id, dateRange, totalDayTaken, checkboxStatus) => {
    setSelectedId(id);
    setSelectedData(item);
    setSelectedTotalDayTaken(totalDayTaken);
    setSelectedDateRange(dateRange);
    setPopup3(!popup3);
    setIsCheckboxActive(checkboxStatus);
  };

  const handleCancel = async () => {
    setIsCanceling(true);

    try {
      await api.post(`leave/time-off/${selectedId}/cancel`).then(() => {
        showToast('Pengajuan cuti berhasil dibatalkan', 'success');
      });
    } catch (err) {
      showToast('Terjadi kesalahan. Silakan coba lagi', 'error');
    } finally {
      setIsCanceling(false);
      setPopup4(false);
      refetch();
    }
  };

  const Tab1 = () => {
    return (
      <div className="border border-1 rounded-4 pt-1 pb-2 overflow-hidden">
        {isLoading ? (
          <FetchStatus type="loading" />
        ) : error ? (
          <FetchStatus type="error" />
        ) : listData?.length > 0 ? (
          <Table responsive hover>
            <thead>
              <tr>
                <th style={{ textAlign: 'center', minWidth: '50px' }} width="20">
                  No.
                </th>
                <th style={{ textAlign: 'center', minWidth: '160px' }} width="200">
                  Dibuat pada
                </th>
                <th style={{ textAlign: 'center', minWidth: '160px' }}>Jenis Cuti</th>
                <th style={{ textAlign: 'center', minWidth: '100px' }}>Mulai</th>
                <th style={{ textAlign: 'center', minWidth: '100px' }}>Berakhir</th>
                <th style={{ textAlign: 'center', minWidth: '100px' }}>Status</th>
                <th style={{ textAlign: 'center', minWidth: '100px' }}>Total</th>
                <th style={{ textAlign: 'center', minWidth: '100px' }} width="100">
                  Aksi
                </th>
              </tr>
            </thead>
            <tbody>
              {listData?.map((item, index) => (
                <tr key={item.id}>
                  <td style={{ textAlign: 'center', verticalAlign: 'middle' }}>
                    {getRowNumber(index, metaData)}
                  </td>
                  <td style={{ textAlign: 'center', verticalAlign: 'middle' }}>
                    <DayView date={item.created_at} time />
                  </td>
                  <td style={{ verticalAlign: 'middle' }}>{item.time_off_master.type}</td>
                  <td style={{ textAlign: 'center', verticalAlign: 'middle' }}>
                    <DayView date={item.date_start} />
                  </td>
                  <td style={{ textAlign: 'center', verticalAlign: 'middle' }}>
                    <DayView date={item.date_end} />
                  </td>
                  <td style={{ textAlign: 'center', verticalAlign: 'middle' }}>
                    {item.status === 'pending' && <MyBadge color="blue">Pending</MyBadge>}
                    {item.status === 'approved' && <MyBadge color="green">Approved</MyBadge>}
                    {item.status === 'rejected' && <MyBadge color="red">Rejected</MyBadge>}
                    {item.status === 'cancelled' && <MyBadge color="purple">Cancelled</MyBadge>}
                    {item.status === 'ignored' && <MyBadge color="yellow">Cancelled</MyBadge>}
                  </td>
                  <td style={{ textAlign: 'center', verticalAlign: 'middle' }}>
                    {item.total_day_taken} Hari
                  </td>
                  <td>
                    <div className="d-flex gap-2">
                      <button
                        type="button"
                        className="btn btn-outline-secondary btn-sm rounded-4"
                        // onClick={() => togglePopup3(item.id, true)}
                        onClick={() =>
                          toggleDetailRequest(
                            item,
                            item?.id,
                            item?.date_range,
                            item?.total_day_taken,
                            // konidisi untuk menampilkan checkbox pengurangan hari
                            (item.time_off_master.type === 'Cuti Tahunan' &&
                              item.status === 'pending') ||
                              (item.time_off_master.type === 'Cuti Tahunan' &&
                                item.status === 'approved'),
                          )
                        }
                      >
                        Detail
                      </button>
                      <button
                        type="button"
                        className="btn btn-outline-danger btn-sm rounded-4"
                        onClick={() => togglePopup4(item.id)}
                        disabled={item.status !== 'pending'}
                      >
                        Cancel
                      </button>
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </Table>
        ) : (
          <FetchStatus type="empty" info="pengajuan cuti" />
        )}

        <Pagination meta={metaData} setPage={setPage} setLimit={setLimit} />

        <Popup
          isOpen={popup1}
          togglePopup={togglePopup1}
          title="Form Pengajuan Cuti"
          isOverflow
          maxHeight
        >
          <FormTimeOff setPopup={setPopup1} refetch={refetch} />
        </Popup>
        <Popup isOpen={popup2} togglePopup={togglePopup2} title="Alasan Cuti">
          <p>
            <i>{`"${selectedReason}"`}</i>
          </p>
        </Popup>

        {popup3 && (
          <TimeOffDetail
            selectedData={selectedData}
            isOpen={popup3}
            togglePopup={toggleDetailRequest}
            selectedId={selectedId}
            dateRange={selectedDateRange}
            totalDayTaken={selectedTotalDayTaken}
            refetch={refetch}
            isCheckboxActive={isCheckboxActive}
          />
        )}

        <PopupConfirmation
          isOpen={popup4}
          loading={isCanceling}
          toggle={togglePopup4}
          handleConfirm={handleCancel}
          btnType="btn-danger"
          title="Konfirmasi"
          message="Apakah anda yakin ingin membatalkan pengajuan ini?"
        />
      </div>
    );
  };

  const Tab2 = () => {
    const [historyData, setHistoryData] = useState([]);

    useEffect(() => {
      async function fetchHistory() {
        await api
          .get('request/time-off/history')
          .then((res) => {
            setHistoryData(res.data.data);
          })
          .catch(() => {
            showToast('Gagal mengambil data history', 'error');
          });
      }

      fetchHistory();
    }, []);

    const fields = [
      {
        field: 'Jenis Cuti',
        key: 'jenis_cuti',
        isCenter: true,
      },
      {
        field: 'Tanggal Efektif',
        key: 'tanggal_efektif',
        isCenter: true,
      },
      {
        field: 'Total Hari',
        key: 'total_hari',
        isCenter: true,
      },
      {
        field: 'Tipe',
        key: 'tipe',
        isCenter: true,
      },
    ];

    const dataList = historyData?.map((item) => {
      return {
        id: item.id,
        jenis_cuti: item.time_off_master.type,
        tanggal_efektif: item.date_start,
        total_hari: item.total_day_taken,
        tipe: item.type,
      };
    });

    return (
      <div className="d-flex flex-column gap-2">
        {dataList?.length > 0 ? (
          <MyTable data={dataList} fields={fields} fieldAction={false} bordered />
        ) : (
          <FetchStatus type="empty" info="riwayat cuti" />
        )}
      </div>
    );
  };

  return (
    <div>
      <div className="d-flex justify-content-between mb-3 flex-column flex-md-row">
        <TabMenu
          setSelectedTab={setSelectedTab}
          selectedTab={selectedTab}
          countData={data?.length}
          menus={tabMenus}
        />
        <div className="d-flex align-items-center gap-3 mt-3 mt-md-0">
          {selectedTab === 1 && (
            <div className="d-flex gap-2">
              <MyButton text="Buat Pengajuan Cuti" action={togglePopup1} type="add" />
            </div>
          )}
        </div>
      </div>
      <Card className="rounded-4">
        <CardBody>
          <div className="d-flex flex-column gap-2">
            {selectedTab === 1 && <Tab1 />}
            {selectedTab === 2 && <Tab2 />}
            {selectedTab === 3 && <Tab3 />}
          </div>
        </CardBody>
      </Card>
    </div>
  );
};

export default RequestTimeOfff;
